<template>
    <div class="back-container" id="back-container">
        <router-link :to="{name: page_name}">
            <span class="icon-back">
                <IconBase><IconArrowBack /></IconBase>
            </span>
            &nbsp;Back
        </router-link>
    </div>
</template>

<script>
import IconArrowBack from '@/components/icons/arrowBack.vue'
import IconBase from '@/components/IconBase.vue'


export default {
    name: "BackButton",
    components: {
        IconArrowBack,
        IconBase
    },
    props: [
        "page_name"
    ],
    data() {
        return {
            page_name: this.page_name
        }
    },
    mounted(){
        var check_page_name =[
            'EducatorStartDateOfPolicy',  
            'AddOnsLegal'
        ];
        var index = check_page_name.indexOf(this.page_name);

        //exist
        if(index != -1) {
            var b = document.getElementById('back-container');
                b.classList.add("back-white");

        } else {
            var b = document.getElementById('back-container').
                b.classList.remove("back-white");

        }
    },
    methods:{
        
    }
}
</script>

<style lang="scss" scoped>
    .back-white{
        a{
            color: #fff
        }
    }
</style>